import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { EnabledShippingTypesState } from './enabled-shipping-types.reducer';

const enabledShippingTypesState = (state: RootState): EnabledShippingTypesState | undefined =>
    state.enabledShippingTypes;

export const selectEnabledShippingTypesSelector = createSelector(
    enabledShippingTypesState,
    (state) => state?.enabledShippingTypes
);
